import colors from "shared/styles/colors";
import { ThemeType } from "shared/styles/theme";
import styled, { css } from "styled-components";
import theme from "styled-theming";

const smallTextBaseColor = theme("mode", {
    [ThemeType.light]: colors.grey_1,
    [ThemeType.dark]: colors.grey_3
})

const ProcessRowSmallTextBase = css`
    color: ${smallTextBaseColor};
    font-size: var(--small-text-font-size);
`

export const ProcessRowLink = styled.a`
    font-size: var(--header-4-font-size);
    white-space: pre-wrap;

`

export const ProcessRowButton = styled.button`
    all: unset;
    font-size: var(--header-4-font-size);
    white-space: pre-wrap;
    cursor: pointer;
`

export const ProcessRowDescription = styled.div`
    ${ProcessRowSmallTextBase};
    flex: 1 1 100%;
    .react-markdown-description p {
        margin: 0;
    }
`

export const ProcessRowVersion = styled.span`
    ${ProcessRowSmallTextBase};
`

export const ProcessRowVersionButton = styled.button`
    all: unset;
    ${ProcessRowSmallTextBase};
    cursor: pointer;
`

const clearFilterLinkColor = theme("mode", {
    [ThemeType.light]: colors.purplePrimary,
    [ThemeType.dark]: colors.grey_2
})

export const ClearFilterLink = styled.p`
    all: unset;
    margin: 12px 0;
    font-size: 1rem;
    color: ${clearFilterLinkColor};
    text-decoration: underline;
    cursor: pointer;
`
